import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { canUploadAttachments } from '../attachments/selectors/canUploadAttachments';
import { dropAttachmentFile } from '../file-uploads/actions/dropAttachmentFile';
import MeetingsLinkContainer from '../meetings-links/containers/MeetingsLinkContainer';
// @ts-expect-error Untyped Module
import { getSelectedThread } from '../selected-thread/selectors/getSelectedThread';
import UnifiedThreadViewWrapperWithDragUpload from '../thread-view/components/UnifiedThreadViewWrapperWithDragUpload';
import ConnectedUnifiedThreadView from '../thread-view/containers/ConnectedUnifiedThreadView';
import { isPersistedThread } from '../threads/operators/isPersistedThread';
import { getShouldDisableAttachments } from '../widget-ui/selectors/getShouldDisableAttachments';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadView = ({
  onSetMessageTextExternally
}) => {
  const shouldDisableDragAndDropUpload = useSelector(state => !isPersistedThread(getSelectedThread(state)) || getShouldDisableAttachments(state) || !canUploadAttachments(state, {
    thread: getSelectedThread(state)
  }));
  const selectedThread = useSelector(getSelectedThread);
  const dispatch = useDispatch();
  const onDropFiles = useCallback(files => {
    if (!selectedThread) return;
    dispatch(dropAttachmentFile(files, selectedThread));
  }, [dispatch, selectedThread]);
  return /*#__PURE__*/_jsxs(UnifiedThreadViewWrapperWithDragUpload, {
    onDropFiles: onDropFiles,
    disabled: shouldDisableDragAndDropUpload,
    children: [/*#__PURE__*/_jsx(MeetingsLinkContainer, {}), /*#__PURE__*/_jsx(ConnectedUnifiedThreadView, {
      onSetMessageTextExternally: onSetMessageTextExternally
    })]
  });
};
ThreadView.displayName = 'ThreadView';
export default ThreadView;